import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'cloudinary-react';

const valiantGreen = '#004438';
const valiantGreenBg = '#F1F9F5';

const ValiantNameEntry = ({ name, onChange, onBlur }) => (
    <div
        className="text-center relative z-10 -mx-8 md:-mx-24 -mt-10 px-8 md:px-24 mb-8"
        css={{ background: valiantGreenBg }}
    >
        <Image
            publicId="v1548278953/valiant-logo.png"
            alt=""
            className="absolute z-10 w-full h-full opacity-10 pin-x pin-y object-cover object-center"
        />
        <div className="py-12 relative z-20">
            <div className="max-w-full mx-auto">
                <h2 className="text-base font-medium text-gray-dark leading-normal">
                    Get recognized on the{' '}
                    <span css={{ color: valiantGreen }}>lavaliantplaysforstjude.org</span> 7s{' '}
                    <span className="whitespace-no-wrap">Donor Leaderboard!</span>
                </h2>
                <div className="my-8">
                    <label htmlFor="displayName" className="hidden">
                        Enter your name or handle
                    </label>
                    <input
                        type="text"
                        id="displayName"
                        name="displayName"
                        placeholder="Enter your name/handle"
                        className="font-medium text-white text-center block w-full rounded py-4 px-6"
                        css={{
                            background: valiantGreen,
                            '::placeholder': {
                                opacity: 1,
                                color: valiantGreenBg,
                            },
                        }}
                        value={name}
                        onChange={e => onChange(e.target.value)}
                        onBlur={onBlur}
                        data-testid="valiant-entry"
                    />
                </div>
                <p className="font-medium text-xs leading-normal" css={{ color: valiantGreen }}>
                    By providing your name, you grant Pledge It permission to display your name and
                    contribution amount on lavaliantplaysforstjude.org.
                </p>
            </div>
        </div>
    </div>
);

ValiantNameEntry.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

ValiantNameEntry.defaultProps = {
    onBlur: () => {},
};

export default ValiantNameEntry;
